import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  initializeRowsFiltersForTicketHistoric,
  setSortConfigForTicketHistoric,
  rowsFiltersForTicketHistoricState,
  sortConfigState,
} from './WagonDetailsPageSlice';

export default function EndAppBarWagonDetails(props) {
  const {
    handleExpandAll,
    handleCollapseAll,
    classes,
    expandedAll,
    collapsedAll,
    selectedTab,
  } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const rowsFilters = useSelector(rowsFiltersForTicketHistoricState);
  const sortConfig = useSelector(sortConfigState);
  const [hasFilters, setHasFilters] = React.useState(false);

  useEffect(() => {
    if (rowsFilters.length > 0 || sortConfig.length > 0) {
      setHasFilters(true);
    }
  }, [rowsFilters, sortConfig]);

  function clearAllFilters() {
    dispatch(initializeRowsFiltersForTicketHistoric());
    dispatch(setSortConfigForTicketHistoric([]));
    setHasFilters(false);
  }

  return (
    <Grid container justify="flex-end" alignItems="flex-end">
      {selectedTab === 'wagonDetails' ? (
        <div>
          <Button
            size="small"
            disableRipple
            className={classes.button}
            color="secondary"
            onClick={handleExpandAll}
          >
            <Typography
              className={
                expandedAll ? classes.expandButton : classes.collapseButton
              }
            >
              {t('Expand all')}
            </Typography>
          </Button>
          <Button
            size="small"
            disableRipple
            className={classes.button}
            color="secondary"
            onClick={handleCollapseAll}
          >
            <Typography
              className={
                collapsedAll ? classes.expandButton : classes.collapseButton
              }
            >
              {t('Collapse all')}
            </Typography>
          </Button>
        </div>
      ) : selectedTab === 'ticketsHistoric' ? (
        <Button
          size="small"
          disableRipple
          className={classes.button}
          color="secondary"
          onClick={clearAllFilters}
        >
          <Typography
            className={
              hasFilters ? classes.collapseButton : classes.expandButton
            }
          >
            {t('clear all filters')}
          </Typography>
        </Button>
      ) : (
        ''
      )}
    </Grid>
  );
}
